import * as geo from './geo.validator';

const DatiqInputValidatorsText = {
    ...geo,
};

export { DatiqInputValidatorsText };
